import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { FiTaskV2HelperService } from '../fi-task-v2-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiTaskV2ReportHelperService } from '../fi-task-v2-report/services/fi-task-v2-report-helper.service';
import { ObjectTypes } from '@fi-shared/types';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';

@Component({
    selector: 'fi-task-v2-navigation-tabs',
    templateUrl: './task-v2-navigation-tabs.component.html',
    styleUrl: './task-v2-navigation-tabs.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-navigation-tabs' },
    standalone: false,
})
export class TaskV2NavigationTabsComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private fiTaskV2HelperService: FiTaskV2HelperService,
        private fiStateService: FiStateService,
        private fiTaskV2ReportHelperService: FiTaskV2ReportHelperService,
        private pageTitleService: PageTitleService,
    ) {
        super(injector);
    }

    public ngOnInit(): void {
        this.pageTitleService.setTitleByItem(ObjectTypes.Task);
        this.tabs = this.fiTaskV2HelperService.getTaskV2SettingsTabs();
        super.updateSelectedTabFromState();
    }

    protected isReportState(): boolean {
        return this.fiStateService.getCurrentStateName() === FiStateNames.TaskV2.Report.Dashboard;
    }

    protected openAddReportWidgetDialog(): void {
        this.fiTaskV2ReportHelperService.triggerOpenAddReportWidgetDialog();
    }
}
